module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-ALTER-2-25-62509025605cd2d216b81ae170000a71.png";